/** V2 — Constantes du tunnel public (choix, libellés). Vouvoiement partout. */

export const MATURITIES = [
  { key: "reflexion",      label: "Je réfléchis",                    hint: "Je me renseigne, rien de concret" },
  { key: "recherche",      label: "Je recherche activement",         hint: "Je visite des biens" },
  { key: "offre_faite",    label: "J'ai fait une offre d'achat",     hint: "En attente de réponse" },
  { key: "offre_acceptee", label: "Mon offre a été acceptée",        hint: "Le compromis n'est pas encore signé" },
  { key: "compromis",      label: "Compromis / promesse signé(e)",   hint: "J'ai une échéance de financement" },
];

export const BIEN_IDENTIFIE = new Set(["offre_faite", "offre_acceptee", "compromis"]);

export const DESTINATIONS = [
  { key: "residence_principale", label: "Résidence principale", emoji: "🏡" },
  { key: "residence_secondaire", label: "Résidence secondaire", emoji: "🏖️" },
  { key: "investissement",       label: "Investissement locatif", emoji: "💰" },
];

export const TYPES_BIEN = [
  { key: "ancien",               label: "Ancien",                 emoji: "🏠" },
  { key: "neuf",                 label: "Neuf / VEFA",            emoji: "🏗️" },
  { key: "terrain_construction", label: "Terrain + construction", emoji: "🌳" },
];
export const TYPE_INCONNU = { key: "inconnu", label: "Pas encore décidé", emoji: "🤷" };

export const DPE_VALUES = ["A", "B", "C", "D", "E", "F", "G"];

export const SITUATIONS = [
  { key: "salarie_prive",  label: "Salarié du privé (CDI)" },
  { key: "fonctionnaire",  label: "Fonctionnaire" },
  { key: "independant",    label: "Indépendant / libéral" },
  { key: "chef_entreprise",label: "Chef d'entreprise" },
  { key: "cdd",            label: "CDD" },
  { key: "interim",        label: "Intérimaire" },
  { key: "retraite",       label: "Retraité" },
  { key: "autre",          label: "Autre situation" },
];

export const ANCIENNETE_SECTEUR = [
  { key: "moins_1an", label: "Moins d'1 an" },
  { key: "1_3ans",    label: "1 à 3 ans" },
  { key: "plus_3ans", label: "Plus de 3 ans" },
];
export const ANCIENNETE_ACTIVITE = [
  { key: "moins_2ans", label: "Moins de 2 ans" },
  { key: "2_3ans",     label: "2 à 3 ans" },
  { key: "plus_3ans",  label: "Plus de 3 ans" },
];
export const AUTRE_DETAILS = [
  { key: "sans_emploi",    label: "Sans emploi" },
  { key: "etudiant",       label: "Étudiant" },
  { key: "conge_parental", label: "Congé parental" },
  { key: "autre",          label: "Autre" },
];

export const REVENU_LABEL = {
  salarie_prive: "Salaire net mensuel avant impôt",
  cdd: "Salaire net mensuel avant impôt",
  interim: "Salaire net mensuel moyen avant impôt",
  fonctionnaire: "Traitement net mensuel avant impôt",
  independant: "Revenu net mensuel d'activité (moyenne)",
  chef_entreprise: "Rémunération nette mensuelle (moyenne)",
  retraite: "Pension nette mensuelle",
  autre: "Revenus nets mensuels (0 si aucun)",
};

export const LOGEMENTS = [
  { key: "proprietaire", label: "Propriétaire", emoji: "🔑" },
  { key: "locataire",    label: "Locataire", emoji: "🏢" },
  { key: "heberge",      label: "Hébergé gratuitement", emoji: "🏠" },
  { key: "autre",        label: "Autre", emoji: "❔" },
];
export const BIEN_ACTUEL = [
  { key: "conserve", label: "Conservé" },
  { key: "vendu",    label: "Vendu pour financer le projet" },
  { key: "indecis",  label: "Je ne sais pas encore" },
];

export const CREDIT_TYPES = [
  { key: "immobilier",   label: "Crédit immobilier" },
  { key: "consommation", label: "Conso / auto / perso" },
  { key: "loa",          label: "LOA / LLD" },
  { key: "autre",        label: "Autre" },
];

export const EPARGNE_RESIDUELLE = [
  { key: "rien",        label: "Quasiment rien" },
  { key: "petite",      label: "Une petite réserve" },
  { key: "confortable", label: "Une réserve confortable" },
];

export const CRENEAUX = [
  { key: "asap",        label: "Dès que possible" },
  { key: "matin",       label: "Matin" },
  { key: "midi",        label: "Midi" },
  { key: "apres_midi",  label: "Après-midi" },
  { key: "fin_journee", label: "Fin de journée" },
];

/** Lot acquisition 1 — consentement recontact : le texte est figé côté serveur (acquisition.CONSENT_TEXTS) ; la version envoyée doit correspondre. */
export const CONSENT_TEXT_VERSION = "recontact_projet_v1";
export const CONSENT_TEXT = "J'accepte que mes coordonnées soient utilisées pour me recontacter dans le cadre de mon projet immobilier.";
export const PHONE_HINT = "Sans indicatif, le numéro est considéré comme français (+33). Pour un numéro étranger, indiquez l'indicatif (ex. +32, +41).";

/** Paramètres d'attribution lus dans l'URL (pas de fbclid / _fbp / _fbc à ce stade). */
export const ATTRIBUTION_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id", "campaign_id", "adset_id", "ad_id"];

export const FAISABILITE_UI = {
  vert:   { emoji: "🟢", color: "var(--cf-success)", bg: "var(--cf-success-soft)", title: "Situation a priori favorable",
            text: "Les informations renseignées présentent plusieurs éléments favorables. Une analyse personnalisée permettra de confirmer précisément votre projet." },
  orange: { emoji: "🟠", color: "var(--cf-warning)", bg: "var(--cf-warning-soft)", title: "Situation à approfondir",
            text: "Votre projet comporte certains éléments qui méritent une analyse plus précise. Un courtier va pouvoir étudier votre situation avec vous." },
  rouge:  { emoji: "🔴", color: "var(--cf-danger)", bg: "var(--cf-danger-soft)", title: "Analyse personnalisée nécessaire",
            text: "Votre situation nécessite une analyse plus approfondie avant de pouvoir nous prononcer sur votre projet." },
};

export const emptyEmprunteur = () => ({
  age: "", situation_pro: null, periode_essai: null, titulaire: null, anciennete: null,
  autre_detail: null, revenus_nets_mensuels: "", revenus_variables: null, revenus_variables_montant: "",
});

export const emptyDraft = () => ({
  stepKey: "landing",
  maturity: null, destination: null, type_bien: null,
  projet_ville: "", projet_code_postal: "", prix_bien: "", prix_cible: "",
  travaux_prevus: null, travaux_montant: "", dpe: null,
  compromis_date: "", condition_suspensive_date: "", cs_inconnue: false,
  nb_emprunteurs: null, nb_enfants: 0,
  emprunteur_1: emptyEmprunteur(), emprunteur_2: emptyEmprunteur(),
  has_autres_revenus: null, autres_revenus: { locatifs: "", pensions: "", autres: "" },
  logement_statut: null, loyer_actuel: "", bien_actuel: null,
  has_credits: null, credits: [],
  has_pension: null, pension_alimentaire: "", autres_charges: "",
  apport: "", epargne_residuelle: null,
  coords: { prenom: "", nom: "", telephone: "", email: "", consent: false, residence_ville: "", residence_code_postal: "" },
});
